// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
import { env } from './.env';

export const environment = {
  production: true,
  hmr: false,
  version: env['npm_package_version'],
  serverUrl: 'https://api.inviertispro.com/api/',
  serverFrontUrl: 'https://inviertispro.com',
  assetsUrl: 'https://d4fg2aztkd4xh.cloudfront.net/assets/',
  cdnUrl: 'https://d2o1y7fs2b9zwy.cloudfront.net',
  defaultLanguage: 'es',
  supportedLanguages: [
    {
      minLag: 'es',
      lang: 'Español',
    },
    {
      minLag: 'en',
      lang: 'English',
    },
  ],
  FACEBOOK_APP_ID: '2447635312195690',
  GOOGLE_APP_ID:
    '119286047765-v6ggo3anl419jcc4carg8jug1mtvohdd.apps.googleusercontent.com',
  GOOGLE_APP_NAME: 'InviertisProperties',
  GOOGLE_MAP_API_KEY: 'AIzaSyCvBFcevUxXxMc8zPiopEueQFTeHRTpJ2M',
  cookieDomain: 'inviertispro.com',
  signatureUrl: 'https://api.signaturit.com/v3',
  SIGNATURE_API_KEY:
    'SPdUgRsQxXJaAzqEbxldqfwySmXywXSgFXOyuNcRLjJolMxhXmVtDiaxbtYgAhOJHZdquYZWzzptOlysgwMRfL',
  AIRCALL_KEYS: {
    API_ID: 'ae5f0b02c01b14d049866c144ddafe3e',
    API_TOKEN: 'd31737bd51ad2c5ffd5e74a4b11a8428',
  },
  serviceHubspot: 'https://api.hsforms.com/submissions/v3/integration/submit/',
};
